import React, { useState, useEffect, useContext } from "react";
import { Navigate, Route, Router, useLocation, Routes } from "react-router-dom";
import { Context } from "./../../../contexts/Store";
import { baseConfig } from "./../../../axiosConfig";

// import "./Dashboard.css";
import NavBar from "./navBar";
import styled from "styled-components";
// import MainDashboard from "./MainDashboard";
import navBarData from "./NavBarData";
import MainDashboard2 from "./MainDashboard2";
import Dashboard from "./Dashboard";
import Program from "../programs/Program";
import Assignments from "../assignments/Assignments";
import SubmitAssignment from "../assignments/SubmitAssignment";
import AssignmentStatus from "../assignmentStatus/AssignmentStatus";
import MySubjects from "../programs/MySubjects";
import Subject from "../programs/Subject";
import TopBar from "./TopBar";
import Profile from "../profile/Profile";
import Notifications from "../notifications/Notifications";
import FreeCourse from "../freeCourses/FreeCourse";
import LiveClasses from "../liveClass/LiveClasses";
import Webinar from "../webinar/Webinar";
import UpcomingWebinar from "../webinar/UpcomingWebinar";
import Faq from "../faq/Faq";
import ClassroomSingle from "../classroom/ClassroomSingle";
import Payments from "../payments/Payments";
import Library from "../library/Library";
import ReadPdf from "../library/ReadPdf";
import PdfComponent from "../library/PdfComponent";
import NotFoundPage from "../../includes/NotFoundPage";
import Result from "../results/Result";
import { TopUpContext } from "../../../contexts/TopUpContext/TopUpStore";
import Announcements from "../announcements/Announcements";
import NavigateLMS from "../navigateLMS/NavigateLMS";

import {
    GetTopUpProgramConst,
    // GetLog,
} from "./../../includes/functions/TopUpFunctions";
import FreeCourseView from "../freeCourses/FreeCourseView";

function Index() {
    const { state } = useContext(Context);
    const { topUpState, topUpDispatch } = useContext(TopUpContext);

    const [isLoading, setLoading] = useState(false);
    const [universityModel, setUniversityModel] = useState("");
    const [universityId, setUniversityId] = useState("");
    const [student, setStudent] = useState({});
    const getStudentsDetails = () => {
        setLoading(true);
        let accessToken = state.user_details.access_token;
        baseConfig
            .get(`students/student-profile/`, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                },
            })
            .then((response) => {
                const { StatusCode, data } = response.data;
                if (StatusCode === 6000) {
                    setStudent(data.data);
                    setUniversityModel(data.university_model);
                    setUniversityId(data.university_id)
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.code === "token_not_valid") {
					localStorage.clear();
					window.location = "/";
				}
                if (error.response?.status == 500) {
                    alert("Server error,Contact LMS");
                }
            });
    };

    useEffect(() => {
        getStudentsDetails();
        GetTopUpProgramConst(state, topUpDispatch);
    }, []);

    return (
        // <Router>
        !isLoading ? (
            <MainContainer>
                <Div>
                    <NavBar
                        data={navBarData}
                        universityModel={universityModel}
                        universityId={universityId}
                        student={student}
                    />
                    <RouterMainDiv>
                        <TopBar student={student} />
                        {/* <Router> */}
                        {/* <Route path="/" element={<MainDashboard />} /> */}
                        {/* <Navigate exact from="/" to="/exam/" />
						<Route path="/exam" component={MainDashboard2} /> */}
                        {/* <Route exact path="/" component={Dashboard} /> */}
                        {/* </Router> */}
                        <Routes>
                            {/* The root path. The `exact` prop is no longer needed in v6. */}
                            <Route
                                path="/"
                                element={<Dashboard student={student} />}
                            />

                            <Route path="/navigate-lms" element={<NavigateLMS/>} />

                            {/* Profile */}
                            <Route
                                path="/profile"
                                element={
                                    <Profile
                                        student={student}
                                        getStudentsDetails={getStudentsDetails}
                                    />
                                }
                            />

                            {/* Programs route. The `component` prop is replaced by `element`. */}
                            <Route path="/program" element={<Program />} />
                            <Route path="/program/subject/:id" element={<MySubjects />} />

                            {/* Assignments routes */}
                            <Route path="/assignments" element={<Assignments />} />
                            <Route path="/assignments/submit/:id" element={<SubmitAssignment />} />
                            <Route path="/assignments-status" element={<AssignmentStatus />} />

                            {/* Exams route */}
                            <Route
                                path="/exam"
                                element={<MainDashboard2 student={student} />}
                            />

                            {/* Announcements route */}
                            <Route path="/announcements" element={<Announcements />} />

                            {/* Free Courses routes */}
                            <Route path="/free-courses" element={<FreeCourse />} />
                            <Route path="/free-courses/:id" element={<FreeCourseView />} />

                            {/* Live Classes route */}
                            <Route path="/live-class" element={<LiveClasses />} />

                            {/* Webinars routes */}
                            <Route path="/webinar" element={<Webinar />} />
                            <Route path="/webinar/upcoming" element={<UpcomingWebinar />} />

                            {/* Notifications route */}
                            <Route path="/notifications" element={<Notifications />} />

                            {/* FAQ route */}
                            <Route path="/faq" element={<Faq />} />

                            {/* Classroom route */}
                            <Route path="/classroom" element={<ClassroomSingle />} />

                            {/* Payments route */}
                            <Route path="/payments" element={<Payments />} />

                            {/* Library routes */}
                            <Route path="/library" element={<Library />} />
                            <Route path="/library/readpdf/:id" element={<PdfComponent />} />

                            {/* Results routes. The old `render` route for results has been removed
                                in favor of the redirect, as having both causes conflicts. */}
                            <Route path="/results" element={<Result universityModel={universityModel} />} />
                            <Route
                                path="/results-redirect" // Created a new path for the redirect to avoid conflict
                                element={
                                    <Navigate
                                        to="/results?section=assignment&period=1"
                                        replace
                                    />
                                }
                            />

                            {/* Page not found (404) route.
                                The catch-all route now uses `path="*"` and the `element` prop. */}
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </RouterMainDiv>
                </Div>
            </MainContainer>
        ) : null
        // </Router>
    );
}

export default Index;

const MainContainer = styled.div`
    padding: 20px;
    background: #f9f9f9;
    // height: 100vh;
    // display: flex;
`;
const RouterMainDiv = styled.div`
    // padding: 30px;
    // background: #f9f9f9;
    // height: 100vh;
    margin-left: 320px;
    @media (max-width: 1500px) {
        margin-left: 70px;
    }
`;
const Div = styled.div`
    // padding: 30px;
    // background: #f9f9f9;
    // height: 100vh;
`;
